import React from "react";
import InputText from "../ReusableComponents/InputText";// Importing the InputText component to be reused
import TextArea from "../ReusableComponents/TextArea";

const ShiftMasterPopup = ({ data }) => {


  return (
    <div class="w-full ">
      <div class=" border-black  "></div>
      {/* <div class="mx-auto flex justify-center lg:w-2/5 md:w-full w-full border-black">
        <div class="relative w-full h-full max-w-xl md:h-auto">
          <div class="relative bg-white rounded-lg shadow ">
            <div class="px-6 py-6 lg:px-8">
              <form class="space-y-6" action="#"> */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 p-4">
        <InputText
          inputType={"text"}
          classStar="text-red-500"
          title={"Shift Name"}
          name={"shift Name"}
          content={data?.ShiftName || ""}
          disabled="disabled"
        />
        <InputText
          inputType="time"
          title="From time"
          name="fromtime"
          rows="4"
          disabled="disabled"
          content={data?.FromTime || ""}
          classStar="text-red-500"
        />
        <InputText
          inputType="time"
          title="To time"
          name="totime"
          rows="4"
          disabled="disabled"
          content={data?.ToTime || ""}
          classStar="text-red-500"
        />
      </div>
      <div className="p-4">

        <TextArea
          title="Description"
          rows={7}
          name="description"
          content={data?.Description ||""}
          resize={false}
          placeholder="Enter description"
          disabled={true}
          // tabIndex="0"
        />
      </div>
      {/* </form>
            </div>
          </div>
        </div>
      </div> */}
    </div>
  );
};
export default ShiftMasterPopup;
